import { useEffect, useState } from "react"
import { useLocation } from "react-router-dom"

const hiddenRoutes = [
  "/activities/flashcards/:id",
  "/activities/diagnostic/:id",
  "/activities/challenge/:id",
  "/activities/lessons/:id",
  "/activities/lessons/:id/summary",
  "/comunications/:id",
  "/comunications/:id/saved-activities",
]

export default function useSidebarVisibility() {
  const [isVisible, setIsVisible] = useState(true)
  const { pathname } = useLocation()

  function shouldHideSidebar(currentPath: string) {
    const matchesPattern = (pattern: string, path: string) => {
      const regexPattern = pattern
        .replace(/:\w+/g, "[^/]+") // Replace dynamic parameters with regex pattern
        .replace(/\//g, "\\/") // Escape slashes

      const regex = new RegExp(`^${regexPattern}$`)
      return regex.test(path)
    }

    return hiddenRoutes.some((route) => matchesPattern(route, currentPath))
  }

  function updateVisibility(currentPath: string) {
    setIsVisible(!shouldHideSidebar(currentPath))
  }

  useEffect(() => {
    updateVisibility(pathname)
  }, [pathname, updateVisibility])

  return { isVisible }
}
